<template>
   <div class="form-group">
      <label
         :for="`ip_${dataName}`"
         :class="['label-overlay', { active: !isNotEmpty(form.data) }]"
         @click="switchLabel($event)"
      >
         {{ placeHolder }}
      </label>
      <select
         :id="`ip_${dataName}`"
         ref="selectBox"
         v-model="form.data"
         :class="[
            'form-control custom-select',
            { 'is-invalid': isValidData.isInvalid },
            { 'is-valid': isValidData.isValid },
         ]"
         :name="dataName"
         @focus="switchLabel($event)"
         @blur="
            switchLabel($event);
            validateFieldData();
         "
         @change="validateFieldData()"
      >
         <option
            v-for="(item, index) in options"
            v-if="isVisible"
            :key="index"
            :value="item.value || item"
         >
            {{ item.text || item }}
         </option>
      </select>
      <div class="invalid-feedback">{{ invalidFeedback }}</div>
      <div class="valid-feedback">{{ validFeedback }}</div>
   </div>
</template>

<script>
export default {
   name: 'SelectComponent',
   props: {
      options: {
         type: Array,
         default: () => [],
      },
      placeHolder: {
         type: String,
         default: 'What describes you best?',
      },
      dataName: {
         type: String,
         default: 'purpose',
      },
      invalidFeedback: {
         type: String,
         default: "Let's connect you to the right team.",
      },
      validFeedback: {
         type: String,
         default: 'Sounds good.',
      },
      selectedIndex: {
         type: Number,
         default: -1,
      },
   },
   data() {
      return {
         isValidData: {
            isValid: false,
            isInvalid: false,
         },
         form: {
            data: '',
         },
         isVisible: false,
      };
   },
   mounted() {
      this.isVisible = true;
      this.$nextTick(() => {
         if (this.selectedIndex > -1) {
            // const item = this.$refs.selectBox.children[this.selectedIndex];
            // item && (item.selected ='selected');
            this.form.data = this.options[this.selectedIndex].value;
         }
      });
   },
   methods: {
      validateFieldData() {
         this.$emit('change', this.form.data);
         this.isValidData.isValid = !this.isNotEmpty(this.form.data);
         this.isValidData.isInvalid = this.$parent.attemptSubmit && this.isNotEmpty(this.form.data);
      },
   },
};
</script>

<style></style>
